"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expandChat = exports.hideChatBox = exports.CHAT_VISITOR_CUSTOMER_FIELDS = exports.CHAT_VISITOR_PHONE_NUMBER = exports.CHAT_VISITOR_EMAIL_ADDRESS = exports.CHAT_VISITOR_FULL_NAME = exports.CHAT_ON_SHRINK = exports.CHAT_EXPAND = exports.CHAT_HIDE = exports.trackingChatEvents = void 0;
exports.trackingChatEvents = [
    [`api.box.onExpand`, `box_expand`],
    [`api.box.onShrink`, `box_shrink`],
    [`api.box.onShow`, `box_show`],
    [`api.chat.onOperatorsAway`, `cops_away`],
    [`api.chat.onOperatorsAvailable`, `cops_avail`],
    [`api.chat.onMessageToVisitor`, `chat_message_in`],
    [`api.chat.onMessageToOperator`, `chat_message_out`],
    [`api.chat.onBeginConversation`, `chat_start`],
];
exports.CHAT_HIDE = 'api.box.hide';
exports.CHAT_EXPAND = 'api.box.expand';
exports.CHAT_ON_SHRINK = 'api.box.onShrink';
exports.CHAT_VISITOR_FULL_NAME = 'api.visitor.updateFullName';
exports.CHAT_VISITOR_EMAIL_ADDRESS = 'api.visitor.updateEmailAddress';
exports.CHAT_VISITOR_PHONE_NUMBER = 'api.visitor.updatePhoneNumber';
exports.CHAT_VISITOR_CUSTOMER_FIELDS = 'api.visitor.updateCustomFields';
const hideChatBox = () => window.olark(exports.CHAT_HIDE);
exports.hideChatBox = hideChatBox;
const expandChat = () => {
    window.olark(exports.CHAT_EXPAND);
};
exports.expandChat = expandChat;
//# sourceMappingURL=fdr-chat.utils.js.map